import { render, staticRenderFns } from "./SwordHeader.vue?vue&type=template&id=23e2337f&scoped=true&"
import script from "./SwordHeader.vue?vue&type=script&lang=js&"
export * from "./SwordHeader.vue?vue&type=script&lang=js&"
import style0 from "./SwordHeader.vue?vue&type=style&index=0&id=23e2337f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e2337f",
  null
  
)

export default component.exports